import { addDoc, collection, getFirestore } from 'firebase/firestore';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import React, { useState } from 'react';
import { currentUser } from '../../util/currentUser';
import { app } from '../../util/firebase';

const AddMedoc = () => {

    const [name,setName] = useState("")
    const [price,setPrice] = useState("")
    const [stock,setStock] = useState(0)
    const [img,setImg] = useState(null)

    let randomNumber = Math.round(Math.random() * 10000)

    const submit =(e)=>{
        e.preventDefault()

        let medoc = {
            name:name,
            price:price,
            stock:stock,
            pharmacie:currentUser,
            isArchived:false,
            imgSrc:'https://firebasestorage.googleapis.com/v0/b/e-sante-dfb1e.appspot.com/o/pharmacie%2Fmedocs%2F'+randomNumber+img.name+'?alt=media'
        }

        const storageRef = ref(getStorage(app),'pharmacie/medocs/'+randomNumber+img.name)
        uploadBytes(storageRef,img)
        .then(result=>{
            addDoc(collection(getFirestore(app),"medocs"),medoc)
            .then(result=>{
                alert("Le médicament a bien été ajouté")
            })
        })
        .catch(err=>alert(err))
    }
    return (
        <div>
            <div className='col-12 col-md-5 m-auto shadow p-3 my-3 my-md-5'>
                <form onSubmit={e=>submit(e)}>
                    <p className='text-center fs-3'>Ajouter un nouveau médicament</p>
                    <input required className='form-control my-3' type="text" placeholder='Nom du médicament' value={name} onChange={e=>setName(e.target.value)}></input>
                    <input required className='form-control my-3' type="number" placeholder='prix de médicament' value={price} onChange={e=>setPrice(e.target.value)}></input>
                    <input required className='form-control my-3' type="number" placeholder='Quantité en stock' value={stock} onChange={e=>setStock(parseInt(e.target.value))}></input>
                    <input required className='form-control my-3' type="file" onChange={e=>setImg(e.target.files[0])}></input>
                    <button className='btn btn-primary col-12'>Ajouter le médicament</button>
                </form>
            </div>
        </div>
    );
};

export default AddMedoc;